import service from './http.js'

// 登录接口
export function loginHttp(data) {
	return service({
		url: '/customerT/login',
		method: 'POST',
		data
	})
}

// 报价单接口
export function getquotationHttp(data) {
	return service({
		url: '/quotation/doQuotationCalculate',
		method: 'POST',
		data
	})
}

// 报价单接口
export function getquotationPDFHttp(data) {
	return service({
		headers: {
			'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		url: '/quotation/printQuotationMultiPdf',
		method: 'POST',
		responseType: 'blob',
		data
	})
}

// 生成CSV
export function getquotationCSVHttp(data) {
	return service({
		url: '/quotation/printQuotationCsv',
		method: 'POST',
		responseType: 'blob',
		data
	})
}
